import revive_payload_client_4sVQNw7RlN from "/builds/projectowners/lawofficesystem/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/builds/projectowners/lawofficesystem/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/builds/projectowners/lawofficesystem/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import plugin_vue3_A0OWXRrUgq from "/builds/projectowners/lawofficesystem/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/builds/projectowners/lawofficesystem/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/builds/projectowners/lawofficesystem/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import pwa_icons_Y6agwlnXZq from "/builds/projectowners/lawofficesystem/node_modules/@vite-pwa/nuxt/dist/runtime/plugins/pwa-icons.mjs";
import pwa_client_Eorgdr12jA from "/builds/projectowners/lawofficesystem/node_modules/@vite-pwa/nuxt/dist/runtime/plugins/pwa.client.mjs";
import unocss_MzCDxu9LMj from "/builds/projectowners/lawofficesystem/.nuxt/unocss.mjs";
import chunk_reload_client_UciE0i6zes from "/builds/projectowners/lawofficesystem/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/builds/projectowners/lawofficesystem/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import api_GFfDXud5Cr from "/builds/projectowners/lawofficesystem/plugins/api.ts";
import element_plus_HUzmwi0JYR from "/builds/projectowners/lawofficesystem/plugins/element-plus.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  pwa_icons_Y6agwlnXZq,
  pwa_client_Eorgdr12jA,
  unocss_MzCDxu9LMj,
  chunk_reload_client_UciE0i6zes,
  check_outdated_build_client_8vK7RkfGxZ,
  api_GFfDXud5Cr,
  element_plus_HUzmwi0JYR
]